/**
 * @file error-handler.service.ts
 * @description handles error by showing Error Dialog
 */
import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import { ErrorComponent, ErrorManagerService, ErrorObject } from '@core';
import { Router } from '@angular/router';
import { AuthService } from '@core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private static readonly className = 'ErrorHandlerService';
  /**
   * @param  ErrorManagerService error manager service
   * @param  MatDialog Material Dialog whish shows error
   */
  constructor(
    private readonly errorManager: ErrorManagerService,
    private readonly authService: AuthService,
    public dialog: MatDialog,
    private router: Router
  ) {
  }
  /**   * @description subscribe to error observable and show error dialog when error occurs
   * @returns void
   */
  public initErrorHandler(): void {
    this.errorManager.getErrorObservable().subscribe((error: ErrorObject) => {
      this.handleError(error);
    });
  }
  /**
   * @param  ErrorObject error object contains title and message
   * @returns void
   */
  private handleError(error: ErrorObject): void {
    const dialogRef: MatDialogRef<ErrorComponent> = this.dialog.open(
      ErrorComponent,
      {
        autoFocus: false,
        minWidth: window.innerWidth < 620 ? 'auto' : 400,
        data: {
          title: error.title,
          message: error.message,
        },
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      if (error.component === 'AccessLevelGuard') {
        this.router.navigateByUrl('/app')
      }
      if (error.component === 'UserAccessGuard') {
        this.authService.logout();
      }
    });
  }
}
